import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-info-modal',
  templateUrl: './generic-info-modal.component.html',
  styleUrl: './generic-info-modal.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericInfoModalComponent {
  constructor(
    private dialogRef: MatDialogRef<GenericInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeModal() {
    this.dialogRef.close();
  }
}
